if (!window.KizenQuickViewInit) {
  window.KizenQuickViewInit = true;

  const QUICK_VIEW_CLOSE_DURATION = 450;
  const ACCORDION_DURATION = 320;
  const ACCORDION_EASING = 'cubic-bezier(.25,.46,.45,.94)';

  /* =========================================
     QUICK VIEW MODAL ANIMATION
  ========================================= */

  function enhanceQuickViewModalAnimation(modal) {
    if (!modal || modal.dataset.quickViewAnimationReady === 'true') return;
    if (typeof modal.hide !== 'function' || typeof modal.show !== 'function') return;

    modal.dataset.quickViewAnimationReady = 'true';

    const baseHide = modal.hide.bind(modal);
    const baseShow = modal.show.bind(modal);

    modal.show = function(opener) {
      this.classList.remove('is-closing');
      this.dataset.quickViewClosing = 'false';
      baseShow(opener);
      requestAnimationFrame(() => syncQuickViewReadMore(this));
    };

    modal.hide = function() {
      if (!this.hasAttribute('open')) return;
      if (this.dataset.quickViewClosing === 'true') return;

      this.dataset.quickViewClosing = 'true';
      this.classList.add('is-closing');

      window.setTimeout(() => {
        this.classList.remove('is-closing');
        this.dataset.quickViewClosing = 'false';
        baseHide();
      }, QUICK_VIEW_CLOSE_DURATION);
    };
  }

  document.querySelectorAll('.quick-view-modal').forEach(enhanceQuickViewModalAnimation);

  const quickViewObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches && node.matches('.quick-view-modal')) {
          enhanceQuickViewModalAnimation(node);
          return;
        }

        if (!node.querySelectorAll) return;

        node.querySelectorAll('.quick-view-modal').forEach(enhanceQuickViewModalAnimation);
      });
    });
  });

  quickViewObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  /* =========================================
     SMOOTH ACCORDION
  ========================================= */

  function getAccordionContent(details) {
    return details.querySelector(':scope > .accordion__content');
  }

  function prepareAccordion(content) {
    content.style.overflow = 'hidden';
    content.style.willChange = 'height';
    content.style.transition = `height ${ACCORDION_DURATION}ms ${ACCORDION_EASING}`;
    content.style.transform = 'translateZ(0)';
    content.style.backfaceVisibility = 'hidden';
  }

  function cleanupAccordion(content) {
    content.style.removeProperty('overflow');
    content.style.removeProperty('willChange');
    content.style.removeProperty('transition');
    content.style.removeProperty('transform');
    content.style.removeProperty('backfaceVisibility');
  }

  function openAccordion(details) {
    if (details.dataset.animating === 'true') return;

    const content = getAccordionContent(details);
    if (!content) return;

    details.dataset.animating = 'true';

    details.setAttribute('open', '');

    prepareAccordion(content);

    content.style.height = '0px';

    requestAnimationFrame(() => {
      const targetHeight = content.scrollHeight;

      content.style.height = targetHeight + 'px';
    });

    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;

      content.style.height = 'auto';

      cleanupAccordion(content);

      details.dataset.animating = 'false';

      content.removeEventListener('transitionend', onEnd);
    };

    content.addEventListener('transitionend', onEnd);
  }

  function closeAccordion(details) {
    if (details.dataset.animating === 'true') return;

    const content = getAccordionContent(details);
    if (!content) return;

    details.dataset.animating = 'true';

    prepareAccordion(content);

    content.style.height = content.scrollHeight + 'px';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
    });

    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;

      details.removeAttribute('open');

      content.style.removeProperty('height');

      cleanupAccordion(content);

      details.dataset.animating = 'false';

      content.removeEventListener('transitionend', onEnd);
    };

    content.addEventListener('transitionend', onEnd);
  }

  document.addEventListener(
    'click',
    function(event) {
      const summary = event.target.closest(
        '.quick-view-modal .combined-product__tabs details > summary'
      );

      if (!summary) return;

      const details = summary.parentElement;

      if (!details) return;

      event.preventDefault();

      const wrapper = details.closest('.combined-product__tabs');

      if (!wrapper) return;

      if (details.hasAttribute('open')) {
        closeAccordion(details);
      } else {

        wrapper.querySelectorAll('details[open]').forEach((otherDetails) => {
          if (otherDetails !== details) {
            closeAccordion(otherDetails);
          }
        });

        openAccordion(details);
      }
    },
    true
  );

  /* =========================================
     PLAN SELECTION
  ========================================= */

  document.addEventListener('change', function(event) {

    const planRadio = event.target.closest(
      'input[type="radio"][name^="quick-view-plan-"]'
    );

    const sellingPlanSelect = event.target.closest(
      '[data-selling-plan-select]'
    );

    const modal = event.target.closest('.quick-view-modal');

    if (!modal) return;

    const sellingPlanInput = modal.querySelector(
      '[data-selling-plan-input]'
    );

    const deliveryWrap = modal.querySelector(
      '[data-delivery-wrap]'
    );

    const planOptions = modal.querySelectorAll(
      '[data-plan-option]'
    );

    const subscriptionDetails = modal.querySelector(
      '[data-subscription-details]'
    );

    if (planRadio) {

      planOptions.forEach((option) => {
        option.classList.remove(
          'combined-product__plan-option--active'
        );
      });

      if (planRadio.closest('[data-plan-option]')) {
        planRadio
          .closest('[data-plan-option]')
          .classList.add(
            'combined-product__plan-option--active'
          );
      }

      if (planRadio.value === 'subscribe') {

        if (deliveryWrap) deliveryWrap.hidden = false;

        if (subscriptionDetails) {
          subscriptionDetails.hidden = false;
        }

        const select = modal.querySelector(
          '[data-selling-plan-select]'
        );

        if (sellingPlanInput && select) {
          sellingPlanInput.disabled = false;
          sellingPlanInput.value = select.value;
        }

      } else {

        if (deliveryWrap) deliveryWrap.hidden = true;

        if (subscriptionDetails) {
          subscriptionDetails.hidden = true;
        }

        if (sellingPlanInput) {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }
    }

    if (
      sellingPlanSelect &&
      sellingPlanInput &&
      !sellingPlanInput.disabled
    ) {
      sellingPlanInput.value = sellingPlanSelect.value;
    }
  });

  /* =========================================
     READ MORE
  ========================================= */

  function syncQuickViewReadMore(modal) {
    const desc = modal.querySelector('[data-quick-view-description]');
    const btn = modal.querySelector('[data-quick-view-read-more]');
    if (!desc || !btn) return;
    if (desc.classList.contains('combined-product__description--expanded')) return;

    desc.classList.add('combined-product__description--truncated');
    const overflows = desc.scrollHeight > desc.clientHeight + 2;

    btn.classList.toggle('combined-product__read-more-btn--visible', overflows);
    if (!overflows) {
      desc.classList.remove('combined-product__description--truncated');
      btn.textContent = 'Read more';
    }
  }

  window.addEventListener('resize', () => {
    document.querySelectorAll('.quick-view-modal[open]').forEach(syncQuickViewReadMore);
  });

  document.addEventListener(
    'click',
    function(event) {

      const quickViewCloseButton = event.target.closest(
        '.quick-view-modal__close'
      );

      if (quickViewCloseButton) {

        const quickViewModal = quickViewCloseButton.closest(
          '.quick-view-modal'
        );

        if (
          quickViewModal &&
          typeof quickViewModal.hide === 'function'
        ) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          quickViewModal.hide();
        }

        return;
      }

      const readMoreButton = event.target.closest(
        '[data-quick-view-read-more]'
      );

      if (!readMoreButton) return;

      const modal = readMoreButton.closest('.quick-view-modal');

      if (!modal) return;

      const description = modal.querySelector(
        '[data-quick-view-description]'
      );

      if (!description) return;

      const isExpanded = description.classList.contains(
        'combined-product__description--expanded'
      );

      if (isExpanded) {

        description.classList.remove(
          'combined-product__description--expanded'
        );

        description.classList.add(
          'combined-product__description--truncated'
        );

        readMoreButton.textContent = 'Read more';

      } else {

        description.classList.remove(
          'combined-product__description--truncated'
        );

        description.classList.add(
          'combined-product__description--expanded'
        );

        readMoreButton.textContent = 'Read less';
      }
    },
    true
  );
}